import clsx from "clsx";
import { ForwardRefRenderFunction, forwardRef } from "react";

import FormFieldText from "@ui/components/cta/FormFieldText";
import SearchIcon from "@ui/components/icon/SearchIcon";

import * as styles from "./Search.css";

interface Props {
  iconClassName?: string;
  inputContainerClassName?: string;
  searchIconContainer?: string;
  inputClassName?: string;
  defaultValue?: string;
  placeholder?: string;
}

const Search: ForwardRefRenderFunction<HTMLInputElement, Props> = (
  {
    iconClassName,
    inputClassName,
    inputContainerClassName,
    defaultValue,
    searchIconContainer,
    placeholder = "Search",
  },
  ref,
) => {
  return (
    <FormFieldText
      name="query"
      type="text"
      label="Search"
      spellCheck="false"
      maxLength={255}
      autoComplete="off"
      placeholder={placeholder}
      className={clsx(inputContainerClassName, styles.inputContainer)}
      inputClassName={clsx(inputClassName, styles.input)}
      ref={ref}
      defaultValue={defaultValue}
      actionButtonContainerClassName={searchIconContainer}
      actionButton={
        <button type="submit" aria-label="Submit Search">
          <SearchIcon
            className={clsx(iconClassName, styles.icon)}
            stroke="none"
            strokeWidth={0.5}
          />
        </button>
      }
      hideLabel
      required
    />
  );
};

export default forwardRef<HTMLInputElement, Props>(Search);
